import { Image, Shape, Slide, Text } from "react-pptx";
import { ActivityData } from "../../../../types/chartData";

import { getColorByValue } from "../../../../helpers/utils";
import { number } from "yup";

type ActivityMLIPainSlideProps = {
  // overallChartB64: string;
  projectName: string;
  compProjectName: string;
  startDate: Date;
  endDate: Date;
  compStartDate: Date;
  compEndDate: Date;
  distributionChartB64: string;
  distributionPainChartB64: string;
  radarChartB64: string;
  activityData1: ActivityData;
  activityData2: ActivityData;
  cutoffDate?: Date;
  mliProgress?: number;
  painProgress?: number;
};

export const ActivityMLIPainSlide: React.FC<ActivityMLIPainSlideProps> = ({
  // overallChartB64,
  projectName,
  compProjectName,
  activityData1,
  activityData2,
  startDate,
  endDate,
  compStartDate,
  compEndDate,
  distributionChartB64,
  distributionPainChartB64,
  radarChartB64,
  cutoffDate,
  mliProgress,
  painProgress,
}) => {
  var overviewTable = { x: 0.1, y: 1.1 }; //0.85
  var radarChartXY = { x: 3.05, y: 1.1 };
  var distributionMLIXY = { x: 0.1, y: 3.8 };
  var distributionPainXY = { x: 3.05, y: 3.8 };

  function getText(progress: number, isPain = false) {
    if (progress > 0 && progress < 0.2 || progress < 0 && progress > -0.2) return;
    var decreased = progress <= 0;
    return (
      <Text
        style={{
          verticalAlign: "middle",
          align: "center",
          x: overviewTable.x + 0.5,
          y: isPain ? overviewTable.y + 2.1 : overviewTable.y + 1.1,
          w: 1.5,
          h: 0.25,
          fontSize: 8,
          bold: true,
          color: decreased ? "#008000" : "#FF0000",
        }}
      >
        {progress.toFixed(1)}% {decreased ? "decrease" : "increase"}
      </Text>
    );
  }

  return (
    <Slide style={{ backgroundColor: "#F9F5F1" }}>
      {/* title */}
      <Text style={{ x: 0.25, y: 0.25, w: "50%", h: 0.3, fontSize: 20 }}>
        {activityData2 ? "Results Comparison" : activityData1.activityName}
      </Text>
      <Shape
        type="rect"
        style={{
          backgroundColor: "#5BBFAC",
          borderColor: "#5BBFAC",
          x: 0.25,
          y: 1,
          h: 0.02,
          w: "40%",
        }}
      />
      <>
        {/* Dataset1 area */}
        {startDate && (
          <>
            <Text
              style={{
                verticalAlign: "top",
                y: 0.85,
                x: "60%",
                w: 2,
                h: 0.5,
                fontSize: 10,
              }}
            >
              Dataset 1:
              {"\n"}
              {activityData1.activityName ?? ""}
              {"\n"}
              {projectName}
            </Text>
            <Text
              style={{
                verticalAlign: "top",
                y: 1.35,
                x: "60%",
                w: 2,
                h: 0.2,
                fontSize: 9,
              }}
            >
              ({startDate.toISOString().split("T")[0]}-
              {endDate.toISOString().split("T")[0]})
            </Text>
          </>
        )}
      </>
      {/* dataset2 area */}
      {activityData2 && (
        <>
          <Text
            style={{
              verticalAlign: "top",
              y: 0.85,
              x: "80%",
              w: 2,
              h: 0.5,
              fontSize: 10,
            }}
          >
            Dataset 2:
            {"\n"}
            {activityData2.activityName ?? ""}
            {"\n"}
            {compProjectName}
            {"\n"}
          </Text>
          <Text
            style={{
              verticalAlign: "top",
              y: 1.35,
              x: "80%",
              w: 2,
              h: 0.2,
              fontSize: 9,
            }}
          >
            ({compStartDate.toISOString().split("T")[0]}-
            {compEndDate.toISOString().split("T")[0]})
          </Text>
        </>
      )}
      {/* Radar chart */}
      <Shape
        type="rect"
        style={{
          y: radarChartXY.y,
          x: radarChartXY.x,
          backgroundColor: "white",
          borderColor: "white",
          w: 2.85,
          h: 2.6,
        }}
      />
      <Image
        src={{ kind: "data", data: radarChartB64 }}
        style={{
          y: radarChartXY.y + 0.1,
          x: radarChartXY.x + 0.1,
          w: 2.65,
          h: 2.4,
        }}
      />
      {/* MLI distribution chart */}
      <Shape
        type="rect"
        style={{
          y: distributionMLIXY.y,
          x: distributionMLIXY.x,
          backgroundColor: "white",
          borderColor: "white",
          w: 2.85,
          h: 1.7,
        }}
      />
      <Image
        style={{
          y: distributionMLIXY.y + 0.1,
          x: distributionMLIXY.x + 0.1,
          w: 2.65,
          h: 1.5,
        }}
        src={{ kind: "data", data: distributionChartB64 }}
      />
      {/* 
        Pain distribution chart */}
      <Shape
        type="rect"
        style={{
          y: distributionPainXY.y,
          x: distributionPainXY.x,
          backgroundColor: "white",
          borderColor: "white",
          w: 2.85,
          h: 1.7,
        }}
      />
      <Image
        style={{
          x: distributionPainXY.x + 0.1,
          y: distributionPainXY.y + 0.1,
          w: 2.65,
          h: 1.5,
        }}
        src={{ kind: "data", data: distributionPainChartB64 }}
      />
      {/* Overview MLI PAIN */}
      <Shape
        type="rect"
        style={{
          y: overviewTable.y,
          x: overviewTable.x,
          backgroundColor: "white",
          borderColor: "white",
          w: 2.85,
          h: 2.6,
        }}
      />
      <Text
        style={{
          y: overviewTable.y + 0.2,
          x: overviewTable.x + 0.75,
          h: 0.3,
          fontSize: 9,
          align: "center",
          verticalAlign: "top",
          w: 1,
        }}
      >
        Dataset 1
      </Text>

      <Text
        style={{
          x: overviewTable.x + 0.1,
          y: overviewTable.y + 0.75,
          w: 0.6,
          h: 0.4,
          fontSize: 14,
          bold: true,
          verticalAlign: "middle",
        }}
      >
        MLI
      </Text>
      <Text
        style={{
          x: overviewTable.x + 1,
          y: overviewTable.y + 0.75,
          w: 0.5,
          h: 0.4,
          fontSize: 14,
          bold: true,
          verticalAlign: "middle",
          align: "center",
          color: getColorByValue(activityData1.average?.mli ?? 0, "MLI", false),
        }}
      >
        {activityData1.average?.mli.toFixed(1) ?? 0}
      </Text>
      <>{cutoffDate && mliProgress && getText(mliProgress)}</>
      <>{cutoffDate && painProgress && getText(painProgress, true)}</>
      {activityData2 && (
        <>
          <Text
            style={{
              x: overviewTable.x + 2,
              y: overviewTable.y + 0.75,
              w: 0.5,
              h: 0.4,
              fontSize: 14,
              bold: true,
              verticalAlign: "middle",
              align: "center",
              color: getColorByValue(
                activityData2.average?.mli ?? 0,
                "MLI",
                false
              ),
            }}
          >
            {activityData2.average?.mli.toFixed(1) ?? 0}
          </Text>
        </>
      )}
      <Text
        style={{
          x: overviewTable.x + 0.1,
          y: overviewTable.y + 1.75,
          w: 0.7,
          h: 0.4,
          fontSize: 14,
          bold: true,
          verticalAlign: "middle",
        }}
      >
        Pain
      </Text>
      <Text
        style={{
          x: overviewTable.x + 1,
          y: overviewTable.y + 1.75,
          w: 0.5,
          h: 0.4,
          fontSize: 14,
          bold: true,
          verticalAlign: "middle",
          align: "center",
          color: getColorByValue(
            activityData1.average?.pain ?? 0,
            "Pain",
            false
          ),
        }}
      >
        {activityData1.average?.pain.toFixed(1)}
      </Text>
      {activityData2 && (
        <>
          <Text
            style={{
              x: overviewTable.x + 2,
              y: overviewTable.y + 1.75,
              w: 0.5,
              h: 0.4,
              fontSize: 14,
              bold: true,
              verticalAlign: "middle",
              align: "center",
              color: getColorByValue(
                activityData2.average?.pain ?? 0,
                "Pain",
                false
              ),
            }}
          >
            {activityData2.average?.pain.toFixed(1) ?? 0}
          </Text>
        </>
      )}
    </Slide>
  );
};

//  <OverallSquareWithBenchmark
//           imageSrc="https://precure-cdn.azureedge.net/images/pain.png"
//           x={3}
//           y1={1}
//           y2={1.95}
//           y3={2.25}
//           averageValue={
//             activityData.average?.pain
//               ? parseFloat(activityData.average?.pain.toFixed(1))
//               : 0
//           }
//           benchmarkValue={
//             activityData.benchmarkPain
//               ? parseFloat(activityData.benchmarkPain.toFixed(1))
//               : 0
//           }
//           title="Pain"
//         />
//function getMLIPercentDifference(
//   averageValue: number,
//   benchmarkValue: number
// ) {
//   if (benchmarkValue < 1) return "";
//   if (!benchmarkValue || !averageValue) return "";
//   const percentDifference =
//     ((averageValue - benchmarkValue) / benchmarkValue) * 100;

//   if (percentDifference === 0) return "";
//   if (percentDifference < 0) {
//     return (
//       <Text
//         style={{
//           verticalAlign: "middle",
//           align: "center",

//           // y: y + 1,
//           // x: x,
//           w: 1.5,
//           h: 0.25,
//           fontSize: 8,
//           bold: true,
//           color: "#008000",
//         }}
//       >
//         {percentDifference.toFixed(1)}% under benchmark
//       </Text>
//     );
//   } else {
//     return (
//       <Text
//         style={{
//           verticalAlign: "middle",
//           align: "center",
//           w: 1.5,
//           h: 0.25,
//           fontSize: 8,
//           bold: true,
//           color: "#FF0000",
//         }}
//       >
//         {percentDifference.toFixed(1)}% over benchmark
//       </Text>
//     );
//   }
// }
